// extracted by mini-css-extract-plugin
export default {"root":"Questionnaires_root__Yl5Kz","tabs":"Questionnaires_tabs__7ub-D","iqTitle":"Questionnaires_iqTitle__pIAuw"};